import {useRunWorkflow} from '@/biz/workflow.jsx'
import {useConfirmMainPackage} from "@/biz/confirmMainPackage";
import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import metaBizNode from '../../metaBizNode.mjs'

export const canAiGenerateCode = () => () => {
    return function (nodes) {
        return [...nodes].filter(node => {
            const {bizNodeType, pkid, prjId} = node.data

            return (
                pkid &&
                prjId === this.data.prjId &&
                /^(BD|SS)$/.test(bizNodeType)
            )
        })
    }
}

export const aiGenerateCode = () => () => {
    const openModal = useOpenModal()
    const runWorkflow = useRunWorkflow()
    const confirmMainPackage = useConfirmMainPackage()

    return async function (nodes) {
        const ns = this.commands.canAiGenerateCode(nodes)

        if (0 === ns.length) {
            await openModal(
                <Alert type="error">
                    只有{metaBizNode.BD.name}或{metaBizNode.SS.name}才能生成代码
                </Alert>
            )

            return
        }

        if (1 < ns.length) {
            await openModal(
                <Alert type="error">
                    只能对单一{metaBizNode.BD.name}或{metaBizNode.SS.name}生成代码
                </Alert>
            )

            return
        }

        const {bdName, pkid, prjId, rev, ssId, ssName, sVer} = ns[0].data
        const mainPackage = await confirmMainPackage({ssId})

        if (! mainPackage) {
            return
        }

        const bizMap = {
            bdId: pkid,
            dpNames: [bdName ?? ssName],
            mainPackage,
            prjId,
            patternId: this.data.prjPatternId,
            rev,
            sVer,
        }

        runWorkflow({bizMap, scene: 'CODE_GENERATION'})
    }
}
